import { render, staticRenderFns } from "./PlateGrid.vue?vue&type=template&id=74920edf&scoped=true&"
import script from "./PlateGrid.vue?vue&type=script&lang=js&"
export * from "./PlateGrid.vue?vue&type=script&lang=js&"
import style0 from "./PlateGrid.vue?vue&type=style&index=0&id=74920edf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74920edf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VFlex,VLayout,VRow,VSelect})
